var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{ref:"echarts",staticClass:"c-chart",attrs:{"option":_vm.option,"autoresize":true},on:{"legendselectchanged":_vm.legendselectchanged}})}
var staticRenderFns = []

export { render, staticRenderFns }